import CONTRATO_ESTIMACIONES from '@/graphql/querys/administracion/ejecucion/estimaciones/contratoEstimaciones.gql';

export default {
  data() {
    return {
      importesDelMes: [],
      importeTotalEstimacion: 0,
    };
  },
  methods: {

    rangoFechas(fechaInicio = false, fechaTermino = false,
      options = { month: 'short', year: 'numeric' }) {
      if (!fechaInicio || !fechaTermino) {
        return [];
      }
      const inicio = new Date(`${fechaInicio} 00:00:0`);
      const fin = new Date(`${fechaTermino} 00:00:0`);
      const UN_DIA_EN_MILISEGUNDOS = 1000 * 60 * 60 * 24;
      const INTERVALO = UN_DIA_EN_MILISEGUNDOS * 1; // Cada semana
      const formateadorFecha = new Intl.DateTimeFormat('es-MX', options);
      const rango = [];

      for (let i = inicio; i <= fin; i = new Date(i.getTime() + INTERVALO)) {
        rango.push(formateadorFecha.format(i).replace(' ', '-'));
      }
      const meses = rango.filter((item, index) => rango.indexOf(item) === index);
      return meses;
    },

    getImportesPorMes() {
      this.importesDelMes = [];

      return this.getEstimaciones
        .slice()
        .sort((a, b) => a.numero > b.numero)
        .filter(({ numero }) => numero <= this.numeroEstimacionAl)
        .sort((a, b) => new Date(`${a.fechaAl} 00:00:0`) - new Date(`${b.fechaAl} 00:00:0`))
        .map((item) => {
          const fechaAl = new Date(`${item.fechaAl} 00:00:0`);
          let fechaInicioMes = '';
          let fechaTerminoMes = '';
          this.importeTotalEstimacion = 0;
          const rangoMeses = this.rangoFechas(item.fechaDel, item.fechaAl, { month: '2-digit', year: 'numeric' });
          if (rangoMeses.length === 1) {
            fechaInicioMes = new Date(`${fechaAl.getFullYear()}-${fechaAl.getMonth() + 1}-01 00:00:0`);
            fechaTerminoMes = new Date(fechaAl.getFullYear(), fechaAl.getMonth() + 1, 0);
            let existe = 0;
            this.importesDelMes.forEach((i) => {
              if (i.fechaTermino.getMonth() === fechaTerminoMes.getMonth()) {
                // eslint-disable-next-line no-param-reassign
                i.importe += item.importeCostoDirecto;
                existe = 1;
              }
            });
            if (!existe) {
              this.importesDelMes.push({
                fechaInicio: fechaInicioMes,
                fechaTermino: fechaTerminoMes,
                importe: item.importeCostoDirecto,
              });
            }
          } else {
            const importePorDia = this.$numberRound(item.importeCostoDirecto
              / this.calcularDiferenciaEnDias(item.fechaDel, item.fechaAl));

            rangoMeses.forEach((r, index) => {
              // **** PRIMER MES
              if (index === 0) {
                fechaInicioMes = new Date(`${r.split('/')[1]}-${r.split('/')[0]}-${new Date(`${item.fechaDel} 00:00:0`).getDate()} 00:00:0`);
                fechaTerminoMes = new Date(r.split('/')[1], r.split('/')[0], 0);
                this.formarImportesDelMes(importePorDia, fechaInicioMes, fechaTerminoMes);
                // ****** ULTIMO MES
              } else if (index === rangoMeses.length - 1) {
                fechaInicioMes = new Date(`${r.split('/')[1]}-${r.split('/')[0]}-01 00:00:0`);
                fechaTerminoMes = new Date(`${r.split('/')[1]}-${r.split('/')[0]}-${new Date(`${item.fechaAl} 00:00:0`).getDate()} 00:00:0`);

                this.formarImportesDelMes(importePorDia, fechaInicioMes,
                  fechaTerminoMes, 1, item.importeCostoDirecto);
                // **** MESES INTERMEDIOS COMPLETOS
              } else {
                fechaInicioMes = new Date(`${r.split('/')[1]}-${r.split('/')[0]}-01 00:00:0`);
                fechaTerminoMes = new Date(r.split('/')[1], r.split('/')[0], 0);

                this.formarImportesDelMes(importePorDia, fechaInicioMes, fechaTerminoMes);
              }
            });
          }
          // Retornar del map
          return true;
        });
    },
    formarImportesDelMes(importePorDia, fechaInicioMes,
      fechaTerminoMes, ultimoRango = 0, importeCostoDirecto = 0) {
      let importePorRango = 0;
      const inicioMes = new Date(`${fechaInicioMes.getFullYear()}-${fechaInicioMes.getMonth() + 1}-01 00:00:0`);
      const terminoMes = new Date(fechaTerminoMes.getFullYear(), fechaTerminoMes.getMonth() + 1, 0);
      const rangoDias = this.calcularDiferenciaEnDias(
        `${fechaInicioMes.getFullYear()}-${fechaInicioMes.getMonth() + 1}-${fechaInicioMes.getDate()}`,
        `${fechaTerminoMes.getFullYear()}-${fechaTerminoMes.getMonth() + 1}-${fechaTerminoMes.getDate()}`,
      );
      if (ultimoRango) {
        importePorRango = this.$numberRound(importeCostoDirecto - this.importeTotalEstimacion);
      } else {
        importePorRango = this.$numberRound(rangoDias * importePorDia);
      }
      this.importeTotalEstimacion += importePorRango;

      // Buscar primer mes del rango para acumular importe
      let existe = 0;
      this.importesDelMes.forEach((i) => {
        // if (i.fechaTermino.getMonth() === fechaTerminoMes.getMonth()) {
        if (inicioMes >= i.fechaInicio && terminoMes <= i.fechaTermino) {
          // eslint-disable-next-line no-param-reassign
          i.importe += importePorRango;
          existe = 1;
        }
      });
      if (!existe) {
        this.importesDelMes.push({
          fechaInicio: inicioMes,
          fechaTermino: terminoMes,
          importe: importePorRango,
        });
      }
    },
    padTo2Digits(num) {
      return num.toString().padStart(2, '0');
    },

  },
  apollo: {
    contratoEstimaciones: {
      query: CONTRATO_ESTIMACIONES,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
  },
  computed: {
    getEstimaciones() {
      if (!this.contratoEstimaciones) return [];
      return this.contratoEstimaciones;
    },

  },
};
